import React, { useState, useRef } from 'react'
import TextField from '@material-ui/core/TextField'

const OTPInput = ({ length = 6, onComplete, setParentOtp }) => {
    const [otp, setOtp] = useState(new Array(length).fill(''))
    const inputRefs = useRef([])

    const handleChange = (index, event) => {
        const value = event.target.value

        if (!/^\d*$/.test(value)) return

        const newOtp = [...otp]
        newOtp[index] = value
        setOtp(newOtp)

        if (value && index < length - 1) {
            inputRefs.current[index + 1]?.focus()
        }

        if (newOtp.every((digit) => digit !== '') && onComplete) {
            setParentOtp(newOtp.join(''))
            onComplete(newOtp.join(''))
        }
    }

    const handleKeyDown = (index, event) => {
        if (event.key === 'Backspace' && !otp[index] && index > 0) {
            inputRefs.current[index - 1]?.focus()
        }
    }

    return (
        <div style={{ display: 'flex', gap: '8px', justifyContent: 'start' }}>
            {otp.map((digit, index) => (
                <TextField
                    key={index}
                    value={digit}
                    onChange={(e) => handleChange(index, e)}
                    onKeyDown={(e) => handleKeyDown(index, e)}
                    inputProps={{
                        maxLength: 1,
                        style: { textAlign: 'center', fontSize: '20px', width: '40px' },
                    }}
                    inputRef={(el) => (inputRefs.current[index] = el)}
                    variant="outlined"
                />
            ))}
        </div>
    )
}

export default OTPInput
